<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'compras-reqcompra-nuevo', params: {} }"
              >
                <i class="fa fa-pencil"></i>
                Nuevo Requerimiento de Compra
              </router-link>
              <h5 class="form-header">
                Requerimiento de Compra &nbsp;
                <span
                  v-if="current.numero != null"
                ># {{ current.numero }}</span>
                &nbsp;
                <div
                  class="badge"
                  :class="{
                      'badge-success': current.estado == 'A',
                      'badge-warning': current.estado == 'B',
                      'badge-danger': current.estado == '9',
                    }"
                >
                  <i class="os-icon os-icon-ui-09"></i>
                  <span v-if="current.estado_str">
                    {{
                    current.estado_str
                    }}
                  </span>
                  <span v-if="!current.estado_str">En Proceso</span>
                </div>

                <div class="st-meta float-right">
                  <div class="element-actions">
                    <button
                      :disabled="current.estado == 'A'"
                      class="btn btn-outline-dark"
                      @click="imprimir"
                      type="button"
                    >
                      <i class="fa fa-print"></i>
                      Imprimir
                    </button>
                    &nbsp;
                    <div class="btn-group">
                      <button
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button
                          class="dropdown-item"
                          :class="{ disabled: !(current.estado == 'B') }"
                          @click="abrir"
                          :disabled="!(current.estado == 'B')"
                          href="#"
                        >
                          <i class="fa fa-unlock"></i>
                          Abrir Operación
                        </button>
                        <button
                          class="dropdown-item"
                          @click="cerrar"
                          :disabled="!(current.estado == 'A')"
                          href="#"
                          type="button"
                        >
                          <i class="fa fa-lock"></i>
                          Cerrar Operación
                        </button>
                        <button
                          class="dropdown-item"
                          @click="anular"
                          :disabled="!(current.estado != '9')"
                          href="#"
                        >
                          <i class="fa fa-archive"></i>
                          Anular Operación
                        </button>
                        <div class="dropdown-divider"></div>
                        <button
                          class="dropdown-item"
                          :disabled="current.estado != 'B'"
                          @click="generar_cotizacion"
                          href="#"
                        >
                          <i class="fa fa-paper-plane"></i>
                          Generar Cotización
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </h5>
              <small
                v-if="current.errors && current.errors.detail"
                class="form-text text-danger"
              >{{ current.errors.detail }}</small>
              <div class="row">
                <div class="col-sm-3">
                  <TiendaSelectComponent :current="current" :isdisabled="current.estado != 'B'" />
                </div>
                <div class="col-sm-6">
                  <ProveedoresSelectComponent :current="current" :disabled="current.estado != 'A'" />
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                          'text-danger':
                            current.errors.tipo &&
                            current.errors.tipo.length > 0,
                        }"
                    >Tipo</label>
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="current.tipo"
                      :disabled="current.estado != 'A'"
                    >
                      <option value="A">Activo</option>
                      <option value="I">Insumo</option>
                      <option value="V">Venta</option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.tipo"
                      class="form-text text-danger"
                    >{{ current.errors.tipo[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                          'text-danger':
                            current.errors.fecha &&
                            current.errors.fecha.length > 0,
                        }"
                    >Fecha</label>
                    <datepicker
                      :bootstrap-styling="true"
                      :format="customFormatter"
                      :disabled="true"
                      v-model="current.fecha"
                    ></datepicker>
                    <small
                      v-if="current.errors && current.errors.fecha"
                      class="form-text text-danger"
                    >{{ current.errors.fecha[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Usuario</label>
                    <input
                      :disabled="true"
                      class="form-control"
                      v-model="current.usuario"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                          'text-danger':
                            current.errors.solicitante &&
                            current.errors.solicitante.length > 0,
                        }"
                    >Solicitante</label>
                    <input
                      v-on:keyup.enter="guardar(current)"
                      v-model="current.solicitante"
                      class="form-control"
                      placeholder="Solicitante"
                      :disabled="current.estado != 'A'"
                      type="text"
                      v-bind:class="{
                          'is-invalid':
                            current.errors.solicitante &&
                            current.errors.solicitante.length > 0,
                        }"
                    />
                    <small
                      v-if="current.errors && current.errors.nombre"
                      class="form-text text-danger"
                    >{{ current.errors.nombre[0] }}</small>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>Comentario</label>
                <textarea
                  v-on:keyup.enter="guardar(current)"
                  v-model="current.comentario"
                  :disabled="current.estado != 'A'"
                  class="form-control"
                  rows="3"
                ></textarea>
              </div>
                <div>
                  <button
                    type="button"
                    class="btn btn-sm btn-secondary btn-block"
                    @click="showModalAddDetail"
                    v-if="current.estado == 'A'"
                  >
                    <i class="fa fa-plus"></i>
                    Agregar Producto
                  </button>
                </div>
                <br>
              <div class="invoice-table" v-if="current.id != null">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Producto</th>
                      <th class="text-center">UM</th>
                      <th class="text-center" style="width: 100px">Cantidad</th>
                      <th class="text-center">Unidades</th>
                      <th class="text-center">Estado</th>
                      <th class="text-center" v-if="current.estado == 'A'"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in current.reqcomprad_set" v-bind:key="detalle.id">
                      <td>
                        {{ detalle.producto.sku }}
                        <br />
                        <small>{{ detalle.producto.nombre }}</small>
                      </td>
                      <td
                        class="text-center"
                        v-if="detalle.unidad_medida"
                      >{{ detalle.unidad_medida.nombre }}</td>
                      <td class="text-center" v-if="!detalle.unidad_medida">Unidad</td>
                        <td
                          class="text-right bolder nowrap"
                          style="font-weight: 500"
                        >
                          <span v-if="current.estado == 'B'">
                            {{ detalle.cantidad_um }}</span
                          >
                          <div
                            class="input-group input-group-sm"
                            v-if="current.estado == 'A'"
                          >
                            <div class="input-group-prepend"></div>
                            <input
                              v-if="current.estado == 'A'"
                              class="form-control text-right"
                              v-model="detalle.cantidad_um"
                              placeholder="cantidad"
                              type="text"
                              v-on:keyup.enter="ModificarDetalle(detalle)"
                            />
                            <div class="input-group-append"></div>
                          </div>
                        </td>
                      <td class="text-center">{{ detalle.cantidad }}</td>
                      <td class="text-center">
                        <span class="status-pill smaller green" v-if="detalle.estado == 'A'"></span>
                        <span class="status-pill smaller red" v-if="detalle.estado == 'B'"></span></span>
                      </td>
                      <td class="text-center" v-if="current.estado == 'A'">
                        <button
                            class="btn btn-sm btn-success"
                            type="button"
                            v-if="current.estado == 'A'"
                            @click="ModificarDetalle(detalle)"
                          >
                            <i class="far fa-save"></i>
                          </button>
                        <button
                          class="btn btn-sm btn-danger mr-1"
                          type="button"
                          @click="deleteDetalle(detalle)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="12"></td>
                    </tr>
                  </tfoot>
                </table>
                <!-------------------- END - Basic Table -------------------->
              </div>
              <div class="form-buttons-w">
                <button
                  class="btn btn-md btn-success"
                  v-if="current.estado == 'A'"
                  @click="guardar(current)"
                  type="button"
                >Guardar</button>
                <router-link class="btn btn-outline-info" :to="{ name: 'compras-reqcompra' }">
                  <i class="fa fa-arrow-left"></i>
                  Listado de Requerimientos
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddDetailReqCompra"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors &&
                          currentDetalle.errors.length > 0,
                      }"
                    ></label>
                    <ProductoSelectComponentV2
                      @onChangeProducto="refreshUnidadMedida"
                      :current="currentDetalle"
                    />
                    <small
                      v-if="currentDetalle.errors"
                      class="form-text text-danger"
                    >{{ currentDetalle.errors.detail }}</small>
                  </div>
                </div>
                <UnidadMedidaSelectComponent class="col-12" :current="currentDetalle" />                
                &nbsp;<small v-if="unidades_medidas" class="form-text text-danger">{{ unidades_medidas }}</small>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors.cantidad_um &&
                          currentDetalle.errors.cantidad_um.length > 0,
                      }"
                    >Cantidad</label>
                    <input
                      v-on:keyup.enter="agregaDetalle"
                      v-model="currentDetalle.cantidad_um"
                      class="form-control"
                      placeholder="Cantidad"
                      type="text"
                      style="text-align: center; font-size: 200%;"
                      v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad_um &&
                          currentDetalle.errors.cantidad_um.length > 0,
                      }"
                    />
                    <small
                      v-if="
                        currentDetalle.errors &&
                          currentDetalle.errors.cantidad_um
                      "
                      class="form-text text-danger"
                    >{{ currentDetalle.errors.cantidad_um[0] }}</small>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregaDetalle" type="button">Agregar</button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import TiendaService from "@/services/catalogos/TiendaService";
import ProveedorService from "@/services/catalogos/ProveedorService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqCompraService from "@/services/compras/ReqCompraService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProveedoresSelectComponent,
    ProductoSelectComponentV2,
    ProductoUnidadMedidaSelectComponent,
    UnidadMedidaSelectComponent,
  },
  watch: {
    $route(to, from) {
      let self = this;

      self.current = {
        id: null,
        tipo: "V",
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        reqcomprad_set: [],
      };
      CommonService.fecha_actual().then((res) => {
        self.current.fecha = res.data.fecha_actual;
      });
      if (this.$route.params.id) {
        self.refreshCurrent();
      }
    },
  },
  data() {
    return {
      current: {
        id: null,
        tipo: "V",
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        reqcomprad_set: [],
      },
      tiendas: [],
      proveedores: [],

      productos: [],
      options: [],
      unidades_medidas: "",

      currentDetalle: {
        cantidad: "",
        unidad_medida: null,
        proveedor: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    defaultValue() {
      let self = this;
      console.log(self.current.productounidadmedida_set);
      if (self.current) {
        self.current.currentDetalle.producto =
          self.current.productounidadmedida_set;
        console.log(self.current.unidad_medida);
      }
    },
    refreshCurrent() {
      let self = this;
      ReqCompraService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.tienda = response.data.tienda.codigo;
        self.selectedProveedor = self.current.proveedor;
        self.current.usuario = response.data.usuario.name;
        // self.current.proveedor = self.current.proveedor.id;
        self.current.fecha = self.customFormatterInverted(self.current.fecha);
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = "";
      });
    },
    guardar(current) {
      let self = this;
      current.tienda = self.current.tienda;
      if (self.current.proveedor) {
        current.proveedor = self.current.proveedor.codigo;
      }
      current.fecha = self.customFormatter(current.fecha);
      ReqCompraService.save(current)
        .then((response) => {
          if (current.id == null) {
            self.$router.push({
              name: "compras-reqcompra-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
            //document.location.reload();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },

    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    customFormatterInverted(date) {
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).add(1, "days").format("YYYY-MM-DD");
    },

    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        $("#modalAddDetailReqCompra").modal();
      });
    },

    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: "",
        unidad_medida: null,
        proveedor: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      };
    },
    ModificarDetalle(detalle) {
      let self = this;
      detalle.producto = detalle.producto.sku;
      detalle.unidad_medida = detalle.unidad_medida.id;
      console.log(detalle.id);
      ReqCompraService.editarDetalle(self.current.id, detalle)
        .then((response) => {
          Notifications.alert.success("Información", "Guardado Correctamente");
          self.refreshCurrent();
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },
    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (self.currentDetalle.unidad_medida.id) {
        det.unidad_medida = self.currentDetalle.unidad_medida.id;
      }
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      ReqCompraService.addDetail(self.current.id, det)
        .then((response) => {
          Notifications.alert.success(
            "Requerimiento de Compra",
            "Se ha guardado la Información."
          );
          self.refreshCurrent();
          self.refreshDetalleDefault();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
        });
    },

    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Compra",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          ReqCompraService.deleteDetail(detalle.req_compra_e, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Compra",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Compra",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          ReqCompraService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Compra",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Compra",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          ReqCompraService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Compra",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Compra",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          ReqCompraService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Compra",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    generar_cotizacion() {
      /**
       * Genera una cotización basada en el requerimiento de compra
       */
      let self = this;
      ReqCompraService.generar_cotizacion(self.current.id)
        .then((response) => {
          let id_cot = response.data.cotizacion_e;
          Notifications.alert.confirm(
            "Cotización Generada",
            "Ir a la Cotizacion Generada",
            "",
            function () {
              self.$router.push({
                name: "compras-cotizaciones-editar",
                params: { id: id_cot },
              });
            }
          );
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    imprimir() {
      let self = this;
      ReqCompraService.pdf(self.current.id)
        .then((response) => {
          console.log(response.data.output);
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    refreshUnidadMedida(producto) {
      let self = this;
      DynamicService.getById("cat", "productos", producto.sku).then((res) => {
        if (res.data.unidad_medida_compra_obj) {
          self.currentDetalle.unidad_medida =
            res.data.unidad_medida_compra_obj.id;
          self.unidades_medidas = "";
        } else {
          self.unidades_medidas =
            "Producto no tiene asignado unidad medida para compra pero puede elegir uno de la lista";
          self.currentDetalle.unidad_medida = "";
        }
      });
    },
  },
};
</script>
